import Create from './Create';
import Item from './Item';
import Card from './Item/card';

export const Robot = () => <></>;

Robot.Item = Item;
Robot.Create = Create;
Robot.Card = Card;
